import { render, staticRenderFns } from "./combo_items.vue?vue&type=template&id=e1705e3a&"
import script from "./combo_items.vue?vue&type=script&lang=coffee&"
export * from "./combo_items.vue?vue&type=script&lang=coffee&"
import style0 from "./combo_items.vue?vue&type=style&index=0&id=e1705e3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports